module.exports = __webpack_public_path__ + "media/images/sp/specials/common/plan_yoso_studio_plus-0eb2fada192348278c9e667ef933dd90.jpg";